/* eslint-disable jsx-a11y/click-events-have-key-events */
import { MouseEvent } from "react";
import { toast } from "react-toastify";
import { FormattedMessage, useIntl } from "react-intl";


export type TrackingLinkForDriverProps = {
  link: string;
  status: string;
};

const TrackingLinkForDriver = function (props: TrackingLinkForDriverProps) {
  const { link, status } = props;
  const intl = useIntl();

  const handleCopyTruckLink = (e: MouseEvent<HTMLSpanElement>) => {
    e.stopPropagation();
    navigator.clipboard.writeText(link);

    toast(
      intl.formatMessage({
        id: "tracking.truckLinkCopied",
        defaultMessage: "Link copied to clipboard",
      }),
      {
        type: "success",
        toastId: "tracking-link-copied",
      },
    );

  };

  return (
    status === "inactive" ? <div className="text-tertiary text-sm italic">
      <FormattedMessage
        id="tracking.truckLinkInactiveMessage"
        defaultMessage="Driver has marked the delivery as completed."
      />
    </div> :
    <div>
      <div className="text-tertiary text-xs">
        <FormattedMessage
          id="tracking.truckLinkShareMessage"
          defaultMessage="Link to share with truck driver for tracking"
        />
      </div>
      <div className="text-brand-secondary text-sm font-semibold cursor-pointer" onClick={handleCopyTruckLink}>
        <FormattedMessage id="tracking.truckCopyLinkMessage" defaultMessage="Copy link to share with driver" />
      </div>
    </div>
  );
};

export default TrackingLinkForDriver;
